// Import util
import 'util/passive-events'

// Import IE Pollyfills
import 'lib/pollyfill-ie'

// Import lib/features
import 'lib/navigation'
import 'lib/truncate-content'
import 'lib/tabs'
import 'lib/scroll-events'
import 'lib/detect-browser'
import '../../app/components/event-lightbox'
import 'lib/wallpaper-download'

// Development only hot module replacement.
// if (process.env.NODE_ENV === 'development' && module.hot) {
//     module.hot.accept()
// }
